import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import Blog from './Blog';
import './Blogs.css';

const Blogs = () => {

    const [blogs, setData] = useState([]);

    useEffect(() => {
        fetch('./blog.json')
            .then(res => res.json())
            .then(data => setData(data))
    }, [])
    console.log(blogs);

    return (
        <><div id="blogs" className="my-5 py-5">
            <h1 style={{ color: "#CCD6F6", fontWeight: "bold" }}>My Blogs</h1>
        </div>
            <div className='blogs'>
                {
                    blogs.map(blog => <Row className='blog' style={{ color: "#8892B0" }}>
                        <Col className='p-5'>
                            <img className='mb-5' src={blog.image} alt="" />
                            <h3 style={{ color: "#CCD6F6", fontWeight: "bold" }}>{blog.blog_title}</h3>
                            <p>{blog.publishing_date}</p>
                            <p>{blog.description}</p>
                            <a target="_blank" href={blog.blog_link} ><button className="custom-button" style={{ marginTop: "0px", textDecoration: "none" }} type="submit" >Read More</button></a>
                        </Col>
                    </Row>)
                }
            </div>
        </>
    );
};

export default Blogs;